import * as React from "react"
import Box from "@mui/material/Box"
import Button from "@mui/material/Button"
import Typography from "@mui/material/Typography"
import Modal from "@mui/material/Modal"
import { colors } from "../../../../styles/commonStyles"
import CloseIcon from "@mui/icons-material/Close"
import {
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material"
import {
  AcceptButton,
  AgreeSubWrapper,
  AgreeWrapper,
  ConditionsDescription,
  ConditionsSubWrapper,
  ConditionsTitle,
  ConditionsWrapper,
  DeclineButton,
  TermsOFServiceBox,
  TermsOFServiceTypo,
  conditions,
} from "./Atom"
import { useLocation } from "react-router"
import { useDispatch } from "react-redux"
import { setIsTermsChecked } from "../../../redux/slices/appSlice"
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "50%",
  bgcolor: "background.paper",
  boxShadow: 24,
}

export default function TermsOfService(props: any) {
  const location = useLocation()
  const dispatch = useDispatch()
  const { open, setOpen, handleOpen, handleClose } = props

  const [isScrolledToBottom, setIsScrolledToBottom] = React.useState(false)

  const handleScroll = (e: any) => {
    const bottom =
      e.target.scrollHeight - e.target.scrollTop < e.target.clientHeight + 100

    setIsScrolledToBottom(bottom)
  }
  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            height: location.pathname === "/auth" ? " 450px" : " 490px",
            borderRadius: "4px",
            // location.pathname === "/auth" ? " 4px" : " 4px 4px 4px 4px",
            ...style,
          }}
        >
          <TermsOFServiceBox>
            <TermsOFServiceTypo>
              Data Privacy Policy & Terms And Conditions Of Use For Pronto
              Application
              <br />
              {/* {location.pathname !== "/auth" ? (
                <span style={{ fontSize: "12px", textDecoration: "underline" }}>
                  Please scroll till the end of the page to accept all Terms and
                  Conditions
                </span>
              ) : (
                ""
              )} */}
            </TermsOFServiceTypo>

            {location.pathname === "/auth" ? (
              <Box sx={{ pr: "20px" }}>
                <IconButton onClick={handleClose}>
                  <CloseIcon sx={{ color: "#fff" }} />
                </IconButton>
              </Box>
            ) : (
              ""
            )}
          </TermsOFServiceBox>

          <ConditionsWrapper
            //onScroll={handleScroll}
            id="scroll"
            sx={{
              maxHeight: "380px",
              //height: location.pathname === "auth" ? "" : "581px",
            }}
          >
            <ConditionsSubWrapper>
              <Typography component="p">
                <Typography sx={{ fontSize: "16px" }}>
                  <b>Last Modified :</b> September 29, 2023
                </Typography>
              </Typography>
              <Typography component="p" sx={{ fontSize: "13px", pt: "10px" }}>
                In this Data Privacy Policy and Terms and Conditions of Use
                (Pronto Application) (<b>“Policy”</b>),Dental Management, LLC,
                now known as Maeva Dental Advisors (<b>“Maeva” "we," "us,"</b>
                or <b>"our"</b>), describes how and why we might collect, store,
                use, and/or share (<b>"process"</b>) your information when you
                download the Pronto application (the <b>“App”</b>) or use Pronto
                and/or related dashboards generated by Maeva (the
                <b> “Services”</b>) through our website, as well as the terms
                and conditions for your use of that App and those Services.
              </Typography>
              <Typography component="p" sx={{ fontSize: "13px", pt: "10px" }}>
                Before clicking on the “accept” button (or making a similar
                indication of acceptance) or accessing or using the App or the
                Services, please carefully read the following Policy. Clicking
                on the accept button (or making a similar indication of
                acceptance) creates a binding agreement.
              </Typography>
              <Typography component="p" sx={{ fontSize: "13px", pt: "10px" }}>
                Use of the Services and/or the App is expressly conditioned on
                your acceptance of and agreement to this Policy, as well as the
                terms of the Master Services Agreement currently in effect,
                which terms (including but not limited to those limiting Maeva’s
                liability and affecting intellectual property rights) are
                incorporated herein by reference. If you do not agree with our
                policies and practices, do not download, register with, or use
                this App. By downloading, registering with, or using this App,
                you agree to this Policy.
              </Typography>
              <Typography component="p" sx={{ fontSize: "13px", pt: "10px" }}>
                <b style={{ fontSize: "15px" }}> Questions or concerns ?</b>{" "}
                Reading this Policy will help you understand your privacy rights
                and choices. If you do not agree with our policies and
                practices, please do not download Maeva’s App or use our
                Services. If you have further questions or concerns, please
                contact us at <a href="">privacy@maevaadvisory.com.</a>
              </Typography>
            </ConditionsSubWrapper>
            <ConditionsSubWrapper>
              <ConditionsSubWrapper>
                {/* Introduction */}
                <ConditionsTitle>1. INTRODUCTION</ConditionsTitle>
                <ConditionsDescription>
                  Maeva respects your privacy, and we are committed to
                  protecting your personal information through our compliance
                  with this Data Privacy Policy for Pronto Application (the{" "}
                  <b>“Policy”</b>). The Policy describes the types of
                  information we may collect or that you may provide when you,
                  download, install, register with, access, or use the Pronto
                  Application (the<b> “App”</b>), as well as our practices for
                  using, maintaining, protecting, and sharing that information.
                </ConditionsDescription>
                <ConditionsDescription>
                  The Policy applies to the information we collect:
                  <ConditionsSubWrapper>
                    <li> On the App.</li>
                    <li>
                      In email, text, and other electronic messages between you
                      and the App.
                    </li>
                  </ConditionsSubWrapper>
                </ConditionsDescription>
                <ConditionsDescription>
                  The Policy does not apply to information collected by us
                  offline or through any other means, including on any other App
                  operated by Maeva or any third party (including our affiliates
                  and subsidiaries).
                </ConditionsDescription>
                <ConditionsDescription>
                  Please read this Policy carefully to understand our policies
                  and practices regarding your information and how we will treat
                  it. If you do not agree with our policies and practices, do
                  not download, register with, or use this App. By downloading,
                  registering with, or using this App, you agree to this Policy.
                  This Policy may change from time to time. Your continued use
                  of this App after we make changes is deemed to be acceptance
                  of those changes, so please check the policy periodically for
                  updates.
                </ConditionsDescription>
                {/* SCOPE */}
                <ConditionsTitle>2. SCOPE</ConditionsTitle>
                <ConditionsDescription>
                  The Policy applies to all App users. This Policy applies
                  whether you access the App through a browser, a mobile
                  application, or any other method. This Policy does not apply
                  to information collected by Maeva offline or through any other
                  means, including on any website operated by Maeva or any third
                  party (including Maeva’s affiliates or subsidiaries) or from
                  any third party, including through any application or content
                  (including advertising) that may link to or be accessible from
                  the App or Maeva’s website.
                </ConditionsDescription>
                <ConditionsDescription>
                  This Policy does not concern or and in no way restricts or
                  limits Maeva’s collection and use of “aggregate data” or
                  “deidentified data.” Aggregate data is information Maeva
                  collects about a group or category of services or users from
                  which individual user identities have been removed.
                </ConditionsDescription>
                <ConditionsDescription>
                  In other words, aggregate data includes no “Personal
                  Information,” as defined below. Maeva may share aggregate data
                  about our users with third parties for various purposes,
                  including to help us better understand our customer needs and
                  improve our services, and for advertising and marketing
                  purposes.
                </ConditionsDescription>
                <ConditionsDescription>
                  This App is intended to be used in the United States of
                  America.
                </ConditionsDescription>
                <ConditionsDescription>
                  The App is not intended for children under 16 years of age,
                  and we do not knowingly collect personal information from
                  children under 16. If we learn we have collected or received
                  personal information from a child under 16 without
                  verification of parental consent, we will delete that
                  information. If you believe we might have any personal
                  information from or about a child under 16, please contact us
                  at <a href="">privacy@maevaadvisory.com</a>.
                </ConditionsDescription>
                {/* WHAT INFORMATION DO WE COLLECT? */}
                <ConditionsTitle>
                  3. WHAT INFORMATION DO WE COLLECT?
                </ConditionsTitle>
                <ConditionsDescription>
                  We collect several types of personal and non-personal
                  information from and about users of our App.{" "}
                  <b>“Personal information,”</b> as used in this Policy, is
                  information that identifies, relates to, describes, is capable
                  of being associated with, or could reasonably be linked to a
                  particular natural person. Some examples of information we may
                  collect includes:
                </ConditionsDescription>
                <TableContainer
                  sx={{
                    borderTop: "1px solid #E3E3E3",
                    borderLeft: "1px solid #E3E3E3",
                    borderRight: "1px solid #E3E3E3",
                    marginTop: "10px",
                  }}
                >
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell
                          sx={{
                            borderRight: "1px solid #E3E3E3",
                            textAlign: "center",
                          }}
                        >
                          <span
                            style={{ fontSize: "16px", fontWeight: "bold" }}
                          >
                            Category
                          </span>
                        </TableCell>
                        <TableCell sx={{ textAlign: "center" }}>
                          <span
                            style={{ fontSize: "16px", fontWeight: "bold" }}
                          >
                            Examples
                          </span>
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        <TableCell sx={{ borderRight: "1px solid #E3E3E3" }}>
                          <span
                            style={{ fontSize: "14px", fontWeight: "bold" }}
                          >
                            Identifiers
                          </span>
                        </TableCell>
                        <TableCell>
                          Name, postal address, email address, birthdate,
                          protected health infromation
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell sx={{ borderRight: "1px solid #E3E3E3" }}>
                          <span
                            style={{ fontSize: "14px", fontWeight: "bold" }}
                          >
                            Professional employment-related information
                          </span>
                        </TableCell>
                        <TableCell>Position title</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell sx={{ borderRight: "1px solid #E3E3E3" }}>
                          <span
                            style={{ fontSize: "14px", fontWeight: "bold" }}
                          >
                            Education information
                          </span>
                        </TableCell>
                        <TableCell>Licensure</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell sx={{ borderRight: "1px solid #E3E3E3" }}>
                          <span
                            style={{ fontSize: "14px", fontWeight: "bold" }}
                          >
                            Commercial information
                          </span>
                        </TableCell>
                        <TableCell>
                          Records of services purchased, payroll, utilization
                          metrics
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell sx={{ borderRight: "1px solid #E3E3E3" }}>
                          <span
                            style={{ fontSize: "14px", fontWeight: "bold" }}
                          >
                            Customer records
                          </span>
                        </TableCell>
                        <TableCell>
                          Financial information, including A/R’s
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
                <ConditionsDescription>
                  The information we request from users includes identifiers,
                  such as name, address, and email address.{" "}
                </ConditionsDescription>
                <ConditionsDescription>
                  All personal information that you provide to us must be true,
                  complete, and accurate, and you must notify us of any changes
                  to such personal information.
                </ConditionsDescription>

                <ConditionsDescription>
                  In order to use the Services, you will provide the App with
                  information about your dental practice, which we refer to as
                  “Customer Data.”
                </ConditionsDescription>
                <ConditionsDescription>
                  <b>How We Collect Your Information </b>
                  Directly From You
                </ConditionsDescription>
                <ConditionsDescription>
                  You provide us some of this information directly, by
                  registering for the App, completing forms in the App,
                  subscribing to our Services, or contacting us directly.
                </ConditionsDescription>
                {/* HOW DO WE USE OR OTHERWISE PROCESS YOUR INFORMATION? */}
                <ConditionsTitle>
                  4. HOW DO WE USE OR OTHERWISE PROCESS YOUR INFORMATION?
                </ConditionsTitle>
                <ConditionsDescription>
                  We use information that we collect about you or that you
                  provide to us, including any personal information:
                </ConditionsDescription>
                <ConditionsSubWrapper
                  sx={{ fontSize: "13px", lineHeight: "30px" }}
                >
                  <li>To present you with the App and its contents;</li>
                  <li>
                    To provide you with information, products, or Services that
                    you request from us;
                  </li>
                  <li>
                    To improve our App, and notify you when updates are
                    available;
                  </li>
                  <li>To recognize you when you use the App;</li>
                  <li>To speed up your searches;</li>
                  <li>For research and development;</li>
                  <li>
                    To carry out Maeva’s obligations and enforce Maeva’s rights
                    arising from any contracts entered into between you and
                    Maeva;
                  </li>
                  <li>
                    To fulfill the purpose for which you provide said
                    information;
                  </li>
                  <li>
                    In any other way we may describe when you provide the
                    information;
                  </li>
                  <li>To respond to legal proceedings and obligations; and</li>
                  <li>For any other purpose, with your consent.</li>
                </ConditionsSubWrapper>
                {/*WHEN AND WITH WHOM DO WE SHARE YOUR INFORMATION? */}
                <ConditionsTitle>
                  5. WHEN AND WITH WHOM DO WE SHARE YOUR INFORMATION?
                </ConditionsTitle>
                <ConditionsDescription>
                  We will not sell your personal information.
                </ConditionsDescription>
                <ConditionsDescription>
                  For business-related purposes, including to optimize our App
                  and the Services Maeva provides, we may share your
                  information, including personal information, with the
                  following parties:
                </ConditionsDescription>
                <ConditionsSubWrapper sx={{ fontSize: "13px" }}>
                  <ul>
                    <li>
                      <b style={{ fontSize: "14px" }}>Affiliates. </b>{" "}
                      <span style={{ fontSize: "13px" }}>
                        We may share your information with our affiliates.
                        Affiliates include our third-party providers, any
                        subsidiaries, joint venture partners, or other companies
                        that we control or that are under common control with
                        us.
                      </span>
                    </li>
                    <hr />
                    <li>
                      <b style={{ fontSize: "14px" }}>
                        Contractors, service providers, and vendors.{" "}
                      </b>
                      <span style={{ fontSize: "13px" }}>
                        We may share your information with contractors, service
                        providers, vendors and business partners Maeva uses to
                        support its business and who are bound by contractual
                        obligations to keep personal information confidential
                        and to use it only for the purposes for which we
                        disclose it to them.
                      </span>
                    </li>
                    <hr />
                    <li>
                      <b style={{ fontSize: "14px" }}>Transferee. </b>
                      <span style={{ fontSize: "13px" }}>
                        Maeva reserves the right to transfer your personal
                        information to a corporate buyer or other successor in
                        the event of a merger, divestiture, restructuring,
                        reorganization, dissolution, or other sale or transfer
                        of some or all of Maeva’s assets, whether as a going
                        concern or as part of bankruptcy, liquidation, or
                        similar proceeding, in which personal information held
                        by Maeva, about our App users is among the assets
                        transferred.
                      </span>
                    </li>
                    <hr />
                    <li>
                      <b style={{ fontSize: "14px" }}>Others. </b>
                      <span style={{ fontSize: "13px" }}>
                        We may also share information, including your personal
                        information, for any other purpose with your consent, or
                        when we believe sharing such information is required by
                        applicable law, regulation, operating license or
                        agreement, legal process or government request, in order
                        to respond to claims that content violates the rights of
                        third parties, or where the disclosure is otherwise
                        appropriate due to safety or other similar concerns.
                      </span>
                    </li>
                    <hr />
                  </ul>
                </ConditionsSubWrapper>
                <ConditionsDescription>
                  Nothing in this Privacy Policy precludes Maeva from
                  collecting, sharing, selling, or otherwise utilizing
                  deidentified, aggregate data.
                </ConditionsDescription>
                <hr />
                {/*WHAT THIRD PARTY SERVICE PROVIDERS WILL YOU PROVIDE INFORMATION TO IN CONJUNCTION WITH OUR APP AND SERVICES? */}
                <ConditionsTitle>
                  6. WHAT THIRD PARTY SERVICE PROVIDERS WILL YOU PROVIDE
                  INFORMATION TO IN CONJUNCTION WITH OUR APP AND SERVICES?
                </ConditionsTitle>
                <ConditionsDescription>
                  In using our App and Services, you may also choose to adopt
                  third party technologies that Maeva recommends for their easy
                  integration with our services (“Preferred Technologies”). Such
                  Preferred Technologies are not controlled by Maeva. Before
                  enrolling in or adopting one of these Preferred Technologies,
                  you should familiarize yourself with the privacy practices of
                  these third parties.{" "}
                </ConditionsDescription>
                {/* HOW WILL WE STORE AND SECURE YOUR INFORMATION? */}
                <ConditionsTitle>
                  7. HOW WILL WE STORE AND SECURE YOUR INFORMATION?
                </ConditionsTitle>
                <ConditionsDescription>
                  We will only keep your personal information for as long as it
                  is necessary for the purposes set out in this privacy notice,
                  unless a longer retention period is required or permitted by
                  law (such as taxes, accounting, or other legal requirements).
                </ConditionsDescription>
                <ConditionsDescription>
                  Maeva reserves the right to delete Customer data, including
                  personal infromation provided by that customer, from its
                  system after thirty (30) days from the termination of its
                  agreement by the applicable customer. Maeva may also delete
                  personal information in response to an individual’s request,
                  as set forth in the Section 10 below.
                </ConditionsDescription>
                <ConditionsDescription>
                  When we have no ongoing legitimate business need to process
                  your personal information, we will either delete or anonymize
                  such information, or, if this is not possible (for example,
                  because your personal information has been stored in backup
                  archives), then we will securely store your personal
                  information and isolate it from any further processing until
                  deletion is possible.
                </ConditionsDescription>
                <ConditionsDescription>
                  Maeva takes reasonable steps to maintain regular data backups
                  and maintain redundant data archives. Nonetheless, Maeva
                  cannot guarantee the occurrence or integrity of any such
                  backup or archive. ACCORDINGLY, MAEVA HAS NO OBLIGATION OR
                  LIABILITY FOR ANY LOSS, ALTERATION, DESTRUCTION, DAMAGE,
                  CORRUPTION, OR RECOVERY OF CUSTOMER DATA.
                </ConditionsDescription>
                <ConditionsDescription>
                  The security of your personal information is important to
                  Maeva. We have implemented administrative, physical, and
                  technical safeguards to protect the personal information Maeva
                  receives from users of its App, as well as other personal
                  information on Maeva’s servers. As discussed above, we require
                  third parties with whom we share personal information to adopt
                  similar precautions to protect personal information.
                </ConditionsDescription>
                <ConditionsDescription>
                  Unfortunately, the transmission of information via the
                  internet is not completely secure. Although we do our best to
                  protect your personal information, we cannot guarantee the
                  security of your personal information transmitted to our App.
                  Any transmission of personal information is at your own risk.
                  We are not responsible for circumvention of any privacy
                  settings or security measures contained on the App.
                </ConditionsDescription>
                {/* WHAT ARE YOUR OBLIGATIONS WITH RESPECT TO THE INFORMATION YOU PROVIDE TO THE APP? */}

                <ConditionsTitle>
                  8. WHAT ARE YOUR OBLIGATIONS WITH RESPECT TO THE INFORMATION
                  YOU PROVIDE TO THE APP?
                </ConditionsTitle>
                <ConditionsDescription>
                  You should employ all physical, administrative and technical
                  controls, screening and security procedures and other
                  safeguards necessary to:
                  <ConditionsSubWrapper>
                    <ol type="a">
                      <li>
                        securely administer the use of all login credentials to
                        and protect against unauthorized access to or use of the
                        App or Services; and
                      </li>
                      <li>
                        control the content and use of Customer Data, including
                        the uploading or provision of Customer Data for
                        processing on the App or through the Services.
                      </li>
                    </ol>
                  </ConditionsSubWrapper>
                </ConditionsDescription>
                <ConditionsDescription>
                  Doctors, dentists, their employees, and their agents should be
                  particularly aware of their obligations of patient
                  confidentiality, including without limitation, their
                  obligations under the Health Insurance Portability and
                  Accountability Act (<b>"HIPAA"</b>), in their communications
                  with Maeva and in determining the manner and extent to which
                  their Customer Data will include Protected Health Information.
                </ConditionsDescription>
                {/* WHAT ARE YOUR RIGHTS REGARDING YOUR PERSONAL INFORMATION? */}
                <ConditionsTitle>
                  9. WHAT ARE YOUR RIGHTS REGARDING YOUR PERSONAL INFORMATION?
                </ConditionsTitle>
                <ConditionsDescription>
                  Depending upon the jurisdiction and governing laws, you may
                  have access to the following rights:
                </ConditionsDescription>
                <ConditionsSubWrapper>
                  <ul>
                    <li>
                      <b style={{ fontSize: "14px" }}>Right to Know </b>{" "}
                      <span style={{ fontSize: "13px" }}>
                        about your personal information being collected by Maeva
                        over the past 12 months and how that information is
                        being used and shared;
                      </span>
                    </li>
                    <li>
                      <b style={{ fontSize: "14px" }}>Right to Delete </b>{" "}
                      <span style={{ fontSize: "13px" }}>
                        your personal information collected by Maeva (subject to
                        several exceptions, when the information is necessary
                        for us or a third party for the purposes described in
                        Section 4 above);
                      </span>
                    </li>
                    <li>
                      <b style={{ fontSize: "14px" }}>
                        {" "}
                        Right to Opt-Out of Sale{" "}
                      </b>{" "}
                      <span style={{ fontSize: "13px" }}>
                        of your personal information; and
                      </span>
                    </li>
                    <li>
                      <b style={{ fontSize: "14px" }}>
                        {" "}
                        Right to Non-Discrimination{" "}
                      </b>{" "}
                      <span style={{ fontSize: "13px" }}>
                        for exercising any of your rights
                      </span>
                    </li>
                  </ul>
                </ConditionsSubWrapper>
                <ConditionsDescription>
                  <b>Note:</b> To respond to user’s assertions of certain
                  rights, we will need to authenticate and/or verify user
                  identity by providing requested information.
                </ConditionsDescription>
                <ConditionsDescription>
                  If you would like to exercise any of the abovementioned
                  rights, please submit a request form by clicking here or by
                  calling (413) 259-4600.
                </ConditionsDescription>
                {/*  HOW CAN YOU UPDATE OR DELETE THE DATA WE COLLECT FROM YOU?  */}
                <ConditionsTitle>
                  10. HOW CAN YOU UPDATE OR DELETE THE DATA WE COLLECT FROM YOU?{" "}
                </ConditionsTitle>
                <ConditionsSubWrapper>
                  <ul>
                    <li>
                      <b style={{ fontSize: "14px" }}>
                        Changing or Correcting Your Account Information or
                        Customer Data:
                      </b>{" "}
                      <span style={{ fontSize: "13px" }}>
                        If your account information, personal information you
                        provide to us via the App, or Customer Data changes, we
                        invite you to correct or update your information as soon
                        as possible. You can make updates to your account
                        information by logging into the App at any time and/or
                        by altering, at its source, the Customer Data you
                        provide to us. You can also request changes or access to
                        your information by emailing privacy@maevaadvisory.com.
                      </span>
                    </li>
                    <li>
                      <b style={{ fontSize: "14px" }}>
                        Deleting Your Account Information or Customer Data:{" "}
                      </b>{" "}
                      <span style={{ fontSize: "13px" }}>
                        Upon your request, Maeva will use commercial reasonable
                        efforts to delete your account, personal information, or
                        Customer Data provided on the App or through the
                        Services. However, it may be impossible to remove this
                        account without some residual data being retained by
                        Maeva. Note, too, that deletion of the App will not
                        necessarily, subject to the terms of the Master Services
                        Agreement, terminate your obligation to pay Maeva for
                        the Services.
                      </span>
                    </li>
                  </ul>
                </ConditionsSubWrapper>
                {/*  DO WE MAKE UPDATES TO THIS POLICY? */}
                <ConditionsTitle>
                  11. DO WE MAKE UPDATES TO THIS POLICY?
                </ConditionsTitle>
                <ConditionsDescription>
                  We may amend this policy from time to time. The date the
                  privacy policy was last modified is identified above. If we
                  make material changes to how we treat our users’ personal
                  information, we will notify you through the App.
                </ConditionsDescription>
                <ConditionsDescription>
                  This Policy may change from time to time. Your continued use
                  of this App after we make changes is deemed to be acceptance
                  of those changes, so please check the policy periodically for
                  updates.{" "}
                </ConditionsDescription>
                {/*   HOW CAN YOU CONTACT US ABOUT THIS POLICY? */}
                <ConditionsTitle>
                  12. HOW CAN YOU CONTACT US ABOUT THIS POLICY?
                </ConditionsTitle>
                <ConditionsDescription>
                  If you have any questions or concerns about Maeva’s Privacy
                  Policy, please contact us{" "}
                  <a href="">privacy@maevaadvisory.com</a> or the street address
                  below:
                </ConditionsDescription>
                <ConditionsDescription
                  sx={{ fontWeight: "bold", fontSize: "14px" }}
                >
                  Privacy Division <br />
                  Maeva Dental Advisors <br />5 Woodland Dell <br />
                  Wilbraham, MA 01095
                  <br /> United States
                </ConditionsDescription>
              </ConditionsSubWrapper>
            </ConditionsSubWrapper>
            {/* {conditions.map((item: any, itemIndex: any) => {
              return (
                <ConditionsSubWrapper key={itemIndex}>
                  <ConditionsTitle>{item.title}</ConditionsTitle>
                  <ConditionsDescription>
                    {item.description}
                  </ConditionsDescription>
                </ConditionsSubWrapper>
              )
            })} */}
          </ConditionsWrapper>

          {location.pathname !== "/auth" ? (
            <AgreeWrapper>
              <AgreeSubWrapper>
                <DeclineButton
                  onClick={() => {
                    handleClose()
                    dispatch(setIsTermsChecked(false))
                  }}
                >
                  Decline
                </DeclineButton>
                <AcceptButton
                  // disabled={!isScrolledToBottom}
                  onClick={() => {
                    handleClose()
                    setIsScrolledToBottom(false)
                    dispatch(setIsTermsChecked(true))
                  }}
                  sx={{
                    backgroundColor: colors.primaryBlue,
                    border: isScrolledToBottom ? "1px solid #3366D6" : "none",
                    // backgroundColor: isScrolledToBottom
                    //   ? colors.primaryBlue
                    //   : "#ABABAB",
                  }}
                >
                  Accept
                </AcceptButton>
              </AgreeSubWrapper>
            </AgreeWrapper>
          ) : (
            ""
          )}
        </Box>
      </Modal>
    </div>
  )
}
